export class TimeConstants {
  public static readonly TWENTY_FOUR_HOUR_TIME_REGEX: RegExp = RegExp(
    '^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$'
  );
}
